import React from 'react';
import './AboutProjectSection.css';
import characterImage from '../../assets/mascote.png'; 

function AboutProjectSection() {
  return (
    <section id="sobre-projeto" className="about-project-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src={characterImage} alt="Personagem ilustrativo" />
          </div>
          <div className="about-text">
            <span className="subtitle">NOSSA SOLUÇÃO</span>
            <h2>Sobre o projeto</h2>
            <p>
              DLOGIC é uma solução digital desenvolvida para otimizar o cálculo e a organização de peças por display na área da PT. Com foco em automação, visualização intuitiva e eficiência, o sistema simplifica tarefas antes manuais, reduzindo erros, economizando tempo e facilitando a tomada de decisões estratégicas na linha de montagem.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutProjectSection;
